import { identifyCustomer } from '../../actioncreators/actioncreators'

const saveBatchSize = 10
const appKey = window.location.host === 'localhost:3000' ? 'com.teamuplabs.em.dev' : 'com.teamuplabs.em'

export const deleteLegacySettings = async () => {
  try {
    const result = await window.AP.request({
      url: `/rest/atlassian-connect/1/addons/${appKey}/properties/settings`,
      type: 'DELETE'
    })

    console.debug('delete legacy settings', result)
  } catch (error) {
    console.debug('delete legacy settings error', error)
  }
}

export const fetchLegacySettings = async () => {
  try {
    const result = await window.AP.request({
      url: `/rest/atlassian-connect/1/addons/${appKey}/properties/settings`,
      type: 'GET'
    })

    if (result.xhr.status === 200) {
      const settings = JSON.parse(result.body)
      console.debug('legacy settings', settings)

      if (settings.value && 
          settings.value.disabledProjects && 
          Array.isArray(settings.value.disabledProjects) && 
          settings.value.disabledProjects.length > 0
      ) {
        return settings.value.disabledProjects
      }

      console.debug('invalid legacy settings')
      return null
    }

    console.debug('failed to get legacy settings', result.xhr.status)
    return null
  } catch (error) {
    if (error.xhr.status === 404) {
      console.debug('no legacy settings found')
      return null
    }

    console.error('failed to get legacy settings', error)
    return null
  }
}

export const fetchProjectEnabledSettings = async (projects) => {
  if (!projects) {
    return null
  }

  const settingsPromises = await Promise.allSettled(projects.map(async project => {
    try {
      const projectDisabled = await fetchProjectIsDisabled(project.key)
      return {
        key: project.key,
        projectDisabled: projectDisabled ? 'disabled' : 'enabled'
      }
    } catch (error) {
      console.error(`error getting disabled state for project ${project.name}`, error)
      return {
        key: project.key,
        projectDisabled: 'error'
      }
    }
  }))

  const settings = settingsPromises.reduce((previous, current) => {
    return {
      ...previous,
      [current.value.key]: current.status === 'fulfilled' ? current.value.projectDisabled : 'error'
    }
  }, {})

  return settings
}

const fetchProjectIsDisabled = async (projectKey) => {
  let result
  try {
    result = await window.AP.request({
      url: `/rest/api/3/project/${projectKey}/properties/com.teamuplabs.em.disabled`,
      type: 'GET'
    })
  } catch (error) {
    if (error.xhr.status === 404) {
      return false
    }

    throw error
  }

  if (result.xhr.status === 200) {
    return JSON.parse(result.body).value === true
  }
  return false
}

export const fetchAllProjects = async () => {
  const pageSize = 50
  let allProjects = []
  let nextProjects = {}
  let nextPageStart = 0

  while (!nextProjects.isLast) {
    nextProjects = await fetchProjects(nextPageStart, pageSize)
    nextPageStart += pageSize

    if (nextProjects) {
      allProjects = [...allProjects, ...nextProjects.values]
    } else {
      return null
    }
  }

  return allProjects
}

const fetchProjects = async (start, pageSize) => {
  try {
    const result = await window.AP.request({
      url: `/rest/api/3/project/search?startAt=${start}&maxResults=${pageSize}`,
      type: 'GET'
    })

    if (result.xhr.status === 200) {
      console.debug('found projects', start, pageSize)
      return JSON.parse(result.body)
    }

    console.debug('failed to get projects', start, pageSize, result.xhr.status)
    return null
  } catch (error) {
    console.error('failed to get projects', start, pageSize, error)
    return null
  }
}

export const updateDisabledProjects = async (projects) => {
  let errorDetected = false
  let saveIndex = 0
  const projectKeys = Object.keys(projects)

  while (saveIndex < projectKeys.length) {
    const savePromises = projectKeys.slice(saveIndex, saveIndex + saveBatchSize).map(projectKey => updateProject(projectKey, projects[projectKey] === 'disabled'))
    const results = await Promise.allSettled(savePromises)

    if (results.some(result => result.status === 'rejected' || !result.value)) {
      errorDetected = true
    }

    saveIndex += saveBatchSize
  }

  return !errorDetected
}

const updateProject = async (project, disabled) => {
  try {
    const result = await window.AP.request({
      url: `/rest/api/3/project/${project}/properties/com.teamuplabs.em.disabled`,
      type: 'PUT',
      data: JSON.stringify(disabled),
      contentType: 'application/json'
    })

    return result.xhr.status === 200 || result.xhr.status === 201
  } catch (error) {
    console.error('failed to save settings', error)
    return false
  }
}

export const recordOpenEvent = async (projects) => {
  await identifyCustomer()
  window.amplitude.getInstance().logEvent('em_admin_open', { projects })
}

export const recordSaveEvent = (changes) => {
  window.amplitude.getInstance().logEvent('em_admin_save', { changes })
}

export const recordSaveFailedEvent = () => {
  window.amplitude.getInstance().logEvent('em_admin_save_failed')
}
